"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputLabel = exports.MuiFilledInput = exports.MuiInput = exports.MuiInputBase = void 0;
var colors_1 = require("../colors");
exports.MuiInputBase = {
    styleOverrides: {
        root: {
            backgroundColor: colors_1.tannerWhite,
            '&:hover': {
                borderColor: colors_1.tannerBlack,
            },
        },
        input: {
            fontSize: 14,
        },
    },
};
exports.MuiInput = {
    defaultProps: {
        disableUnderline: true,
    },
};
exports.MuiFilledInput = {
    defaultProps: { disableUnderline: true },
    styleOverrides: {
        root: {
            backgroundColor: colors_1.tannerWhite,
            paddingRight: 8,
            '&:hover': {
                backgroundColor: colors_1.tannerWhite,
                borderColor: '#000',
            },
            '&.Mui-disabled': {
                backgroundColor: colors_1.tannerGray['50'],
                color: colors_1.tannerGray['400'],
                WebkitTextFillColor: colors_1.tannerGray['400'],
            },
        },
        adornedStart: {
            paddingLeft: 16,
        },
        inputAdornedStart: {
            paddingLeft: 0,
        },
        inputAdornedEnd: {
            paddingRight: 16,
        },
        input: {
            paddingLeft: 16,
        },
        inputMultiline: {
            paddingLeft: 4,
        },
    },
};
exports.MuiInputLabel = {
    styleOverrides: {
        root: {
            color: colors_1.tannerGray['600'],
            fontWeight: 500,
            '&.Mui-error,&.Mui-error.Mui-focused': {
                color: colors_1.tannerSemantic.error.color,
            },
            '&.Mui-focused': {
                color: colors_1.tannerGray['600'],
            },
            '&.Mui-disabled': {
                color: colors_1.tannerGray['400'],
            },
        },
        filled: {
            maxWidth: '65%',
            color: colors_1.tannerGray['600'],
            fontWeight: 500,
            transform: 'translate(17px, 20px) scale(1)',
            '&.MuiInputLabel-shrink': {
                transform: 'translate(17px, 12px) scale(.8)',
                maxWidth: '100%',
            },
            '&.MuiInputLabel-sizeSmall': {
                transform: 'translate(17px, 16px) scale(1)',
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(17px, 8px) scale(.8)',
                    maxWidth: '100%',
                },
            },
        },
        outlined: {
            color: colors_1.tannerGray['600'],
            fontWeight: 500,
            transform: 'translate(17px, 20px) scale(1)',
            '&.MuiInputLabel-shrink': {
                transform: 'translate(17px, -6px) scale(.8)',
                maxWidth: '100%',
            },
            '&.MuiInputLabel-sizeSmall': {
                transform: 'translate(17px, 11px) scale(1)',
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(17px, -6px) scale(.8)',
                    maxWidth: '100%',
                },
            },
        },
    },
};
//# sourceMappingURL=MuiInput.js.map